<template>
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h4 class="mb-0">{{blockTitle}}</h4>
    <div class="d-flex align-items-center gap-2">
      <router-link
        v-if="importRoutName !== ''"
        :to="{ name: importRoutName}"
        class="btn btn-primary d-flex align-items-center"
        :aria-label="importButtonTitle"
        :title="importButtonTitle"
      >
        <i class="bi bi-cloud-upload"></i>
        <span class="ms-2">{{ importButtonTitle }}</span>
      </router-link>
      <router-link :to="{ name: detailRoutName, params: { id: 'new' } }" class="btn btn-primary d-flex align-items-center">
        <i class="bi bi-plus-lg"></i>
      </router-link>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-hover align-middle">
      <thead class="table-light">
      <tr>
        <th v-for="title in titles" :class="title.key==='id'?'id-block':''">{{title.title}}</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in rows" :key="item.id">
        <td v-for="title in titles" :title="title.title" :class="title.key==='id'?'id-block':''">{{item[title.key]}}</td>
        <td class="text-end">
          <router-link :to="{ name: detailRoutName, params:{ id: item.id } }" class="btn btn-sm btn-outline-primary">
            <i class="bi bi-eye"></i>
          </router-link>
        </td>
      </tr>

      </tbody>
    </table>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

const props = defineProps({
  blockTitle: {type: String, default: () => "" },
  rows: {type: Array, default: () => [] },
  titles: {type: Array, default: () => [] },
  detailRoutName: {type: String, default: () => "" },
  importRoutName: {type: String, default: () => "" },
  importButtonTitle: {type: String, default: () => "Імпорт" },
})
</script>
<style scoped lang="scss">
.id-block {
  text-align: left;
  width: 236px;
}
</style>
